import { render, staticRenderFns } from "./TdxInput.vue?vue&type=template&id=59e79a86&scoped=true&"
import script from "./TdxInput.vue?vue&type=script&lang=js&"
export * from "./TdxInput.vue?vue&type=script&lang=js&"
import style0 from "./TdxInput.vue?vue&type=style&index=0&id=59e79a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e79a86",
  null
  
)

export default component.exports